import { createContext } from "react";

const MqttContext = createContext({});
export default MqttContext;
